export const HANDLE_CHECKBOX = "HANDLE_CHECKBOX";

interface HandleCheckboxAction {
	type: typeof HANDLE_CHECKBOX
	payload: any
}


export type SidebarCheckboxesTypes = HandleCheckboxAction
